import { useRecoilState, useRecoilValue } from 'recoil';

import {
  carTypeState,
  filtersQuerySelector,
  hasFiltersQuerySelector,
  isClearedState,
  isInitialQueryState,
} from '@/states/used-cars/filter-query.state';

export function useFiltersQuery() {
  const hasFiltersQuery = useRecoilValue(hasFiltersQuerySelector);
  const filtersQuery = useRecoilValue(filtersQuerySelector);
  const [isInitialQuery, setIsInitialQuery] =
    useRecoilState(isInitialQueryState);

  const [isCleared, setIsCleared] = useRecoilState(isClearedState);

  const [activeCarType, setActiveCarType] = useRecoilState(carTypeState);

  return {
    hasFiltersQuery,
    filtersQuery,
    isInitialQuery,
    setIsInitialQuery,
    activeCarType,
    setActiveCarType,
    isCleared,
    setIsCleared,
  };
}
